import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareMediaComponent } from './components/share-media/share-media.component';
import { ShareMediaRouting } from './share-media.routing';

@NgModule({
	declarations: [ShareMediaComponent],
	imports: [CommonModule, ShareMediaRouting]
})
export class ShareMediaModule {}
